export default __webpack_public_path__ + "static/media/w-sample.c36b470c.jpg";